// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import PipHistory from '@deere/cps-it.warranty-model-factory/lib/pip-history';
import PipHistoryItem from './pip-history-item';

const PipHistoryPanel = props => {

    const pipHistoryPanelTitle = (
        <div>
            <FormattedMessage id='PIP_HISTORY'/> {` (${props.pips.length})`}
        </div>
    );

    const pipHistoryPanelBody = props.pips.map(pip =>
        <PipHistoryItem
            key={pip.pipId}
            pin={props.pin}
            pip={pip}
        />
    );

    return (

        <Accordion
            accordionId='pip-history-panel-accordion'
            body={pipHistoryPanelBody}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            title={pipHistoryPanelTitle}
        />

    );

};

PipHistoryPanel.displayName = 'PipHistoryPanel';
PipHistoryPanel.propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired,
    pips: PropTypes.arrayOf(PropTypes.instanceOf(PipHistory)).isRequired
};

export default PipHistoryPanel;



// WEBPACK FOOTER //
// ./src/product/details/components/pip-history-panel.js